import { observer } from "mobx-react";
import React, { useState, useEffect } from "react";
import {
  Modal,
  Stack,
  TextInput,
  Paper,
  Group,
  Button,
  Text,
  Code,
  Overlay,
  Box,
  Alert,
  Loader,
  ModalTitle,
} from "@mantine/core";

import { MODAL_WIDTH_FOR_DATA_INTENSIVE_MODALS } from "../../../helpers/constants";
import { BOB_MODALS, maxNumberOfVaults } from "../../helpers/constants";
import { Bob } from "../../stores/Bob";
import { IconAlertTriangle, IconLockPlus } from "@tabler/icons-react";
import { CustomModalTitle } from "../details/customModalTitle";
import { pluralize } from "../../helpers/formatNumbers";

const CreateNewBobModal = observer(({ bob }: { bob: Bob }) => {
  const handleClose = () => {
    bob.setOpenModal(null);
  };

  return (
    <Modal
      opened={bob.openModal === BOB_MODALS.CREATE_NEW_BOB}
      onClose={handleClose}
      title={
        <CustomModalTitle text="Create New Vault" icon={<IconLockPlus />} />
      }
    >
      <Paper withBorder shadow="md" p={24} radius="md">
        <Stack>
          <Text>
            You have {bob.workspace.bobs.length}{" "}
            {pluralize(bob.workspace.bobs.length, "vault")}.{" "}
          </Text>{" "}
          <Text>You can create {maxNumberOfVaults} vaults in total. </Text>{" "}
          <Text>
            Each vault has its own Lightning Address, transaction history, and
            fiat currency settings.
          </Text>
          <Button
            onClick={() =>
              bob.sendDataAndDirectiveToRails("make-a-new-bob", {})
            }
            disabled={bob.areWeWaitingOnRails}
          >
            Create New Vault
          </Button>
          {bob.areWeWaitingOnRails && <Loader></Loader>}
        </Stack>
      </Paper>
    </Modal>
  );
});

export default CreateNewBobModal;
